import { isEmpty } from 'lodash-es'
import { connect } from 'scrivito'

import { StringText } from '@/Atomic/Atoms/StringText'
import { CellRendererParams } from '@/Components/EntityTable/types'
import { SchemaAttributes } from '@/Data/types'
import { SchemaAttribute } from '@/Data/typesV2'
import { getReferenceDataItem } from '@/utils/CRUD/read/reference'
import { getDataItemTitle } from '@/utils/dataClassMap'
import { ensureString } from '@/utils/ensureString'
import { getLocalizedSchemaAttributes } from '@/utils/schemaLocalization'

export const SingleContactReferenceCell = connect(
  ({ dataItem, column, schema }: CellRendererParams) => {
    const attribute = getLocalizedSchemaAttributes(
      schema.get('attributes') as SchemaAttributes,
    )?.[column.accessor] as SchemaAttribute | undefined

    const referenceItem = getReferenceDataItem(
      attribute,
      dataItem.get(column.accessor),
    )
    const label = ensureString(getDataItemTitle(referenceItem))

    if (isEmpty(label)) {
      return <StringText value="-" />
    }

    return <StringText variant="link" value={label} dataItem={referenceItem} />
  },
)
